// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { SelectPresentationProps } from "@insite/mobius/Select/Select";
import { TextFieldProps } from "@insite/mobius/TextField";

customerAddressFormFieldStyles.firstNameGridItem = {
    width: [12, 12, 6, 6, 6],
};

customerAddressFormFieldStyles.firstNameText = {
    placeholder: translate("First Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.lastNameGridItem = {
    width: [12, 12, 6, 6, 6],
};

customerAddressFormFieldStyles.lastNameText = {
    placeholder: translate("Last Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.companyNameText = {
    placeholder: translate("Company Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.companyNameGridItem = {
    width: [12, 12, 12, 12, 12],
};

customerAddressFormFieldStyles.attentionText = {
    placeholder: translate("Attention"),
} as TextFieldProps;

customerAddressFormFieldStyles.attentionGridItem = {
    width: [12, 12, 6, 6, 6],
};

customerAddressFormFieldStyles.address1Text = {
    placeholder: translate("Address 1"),
} as TextFieldProps;

customerAddressFormFieldStyles.address2Text = {
    placeholder: translate("Address 2"),
} as TextFieldProps;

customerAddressFormFieldStyles.address3Text = {
    placeholder: translate("Address 3"),
} as TextFieldProps;

customerAddressFormFieldStyles.address4Text = {
    placeholder: translate("Address 4"),
} as TextFieldProps;

customerAddressFormFieldStyles.countrySelect = {
    placeholder: translate("Country"),
} as SelectPresentationProps;

customerAddressFormFieldStyles.stateGridItem = {
    width: [12, 12, 6, 6, 6],
};

customerAddressFormFieldStyles.cityText = {
    placeholder: translate("City Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.postalCodeGridItem = {
    width: [12, 12, 6, 6, 6],
};

customerAddressFormFieldStyles.postalCodeText = {
    placeholder: translate("Postal Code"),
} as TextFieldProps;

customerAddressFormFieldStyles.phoneGridItem = {
    width: [12, 12, 12, 12, 12],
};

customerAddressFormFieldStyles.phoneText = {
    placeholder: translate("Phone Number"),
} as TextFieldProps;

customerAddressFormFieldStyles.faxGridItem = {
    width: [12, 12, 6, 6, 6],
};

customerAddressFormFieldStyles.emailText = {
    placeholder: translate("Email"),
} as TextFieldProps;
